<template>
  <div>
    <v-window
      id="container"
      v-model="window"
      class="elevation-1"
      :vertical="vertical"
      :show-arrows="showArrows"
      :reverse="reverse"
    >
        <v-window-item
        v-for="n in length"
        :key="n"
        >
            <v-card flat >
            <v-card-text>
                <div id="imgContainer">
                   <!--
                    <div>
                    <v-img v-if="n==1" src="../assets/banner/foto1.jpg" class="initialImg"></v-img>
                    <p v-if="n==1"  class="imgText">Respetamos el medio ambiente.</p>
                    <v-img v-if="n==2" src="../assets/banner/foto4.jpg" class="initialImg"></v-img>
                    <p v-if="n==2" class="imgText">Reutilizando.</p>
                    <v-img v-if="n==3" src="../assets/banner/foto5.jpg" class="initialImg"></v-img>
                    <p v-if="n==3" class="imgText">Reciclando.</p>
                    <v-img v-if="n==4" src="../assets/banner/foto6.jpg" class="initialImg"></v-img>
                    <p v-if="n==4" class="imgText">Reduciendo.</p>
                    <v-img v-if="n==5" src="../assets/banner/foto7.jpg" class="initialImg"></v-img>
                    <p v-if="n==5" class="imgText">Recuperando.</p>
                    <v-img v-if="n==6" src="../assets/banner/foto8.jpg" class="initialImg"></v-img>

                    <p v-if="n==6" class="imgText">Óptima gestión.</p>

                    <v-img v-if="n==7" src="../assets/banner/foto9.jpg" class="initialImg"></v-img>

                    <p v-if="n==7" class="imgText">Renovación de flota.</p>

                    <v-img v-if="n==8" src="../assets/banner/foto10.jpg" class="initialImg"></v-img>

                    <p v-if="n==8" class="imgText">Consumos energéticos reducidos.</p>

                    <v-img v-if="n==9" src="../assets/banner/foto11.jpg" class="initialImg"></v-img>

                    <p v-if="n==9" class="imgText">Personal cualificado.</p>

                    <v-img v-if="n==10" src="../assets/banner/foto12.jpg" class="initialImg"></v-img>
                    <p v-if="n==10" class="imgText">Certificación ISO14001.</p>
                    </div>
                    -->
                    <!--

Reducción de los residuos producidos

                      -->




                    <div>
                      
                    <v-img v-if="n==1" src="../assets/banner/foto12.jpg" class="initialImg"></v-img>
                    <p v-if="n==1" class="imgText">Certificación ISO14001</p>
                    <v-img v-if="n==2" src="../assets/banner/foto1.jpg" class="initialImg"></v-img>
                    <p v-if="n==2"  class="imgText">Protección del medio ambiente </p>
                    <v-img v-if="n==3" src="../assets/banner/foto2.jpg" class="initialImg"></v-img>
                    <p v-if="n==3" class="imgText">Reducir, Reutilizar, Recuperar y Reciclar</p>
                    <v-img v-if="n==4" src="../assets/banner/foto17.jpg" class="initialImg"></v-img>
                    <p v-if="n==4" class="imgText">Consumo responsable</p>
                    <v-img v-if="n==5" src="../assets/banner/foto18.jpg" class="initialImg"></v-img>
                    <p v-if="n==5" class="imgText">Desarrollo sostenible </p>
                    <v-img v-if="n==6" src="../assets/banner/foto5.jpg" class="initialImg"></v-img>
                    <p v-if="n==6" class="imgText">Sistema de gestión ecológica </p>
                    <v-img v-if="n==7" src="../assets/banner/foto20.jpg" class="initialImg"></v-img>
                    <p v-if="n==7" class="imgText">Recogida selectiva de residuos</p>
                    <v-img v-if="n==8" src="../assets/banner/foto7.jpg" class="initialImg"></v-img>
                    <p v-if="n==8" class="imgText">Economía y Política medioambiental </p>
                    <v-img v-if="n==9" src="../assets/banner/foto8.jpg" class="initialImg"></v-img>
                    <p v-if="n==9" class="imgText">Asesoramiento medioambiental </p>
                    <v-img v-if="n==10" src="../assets/banner/foto21.jpg" class="initialImg"></v-img>
                    <p v-if="n==10" class="imgText">Intervención en vertidos</p>
                    <v-img v-if="n==11" src="../assets/banner/foto10.jpg" class="initialImg"></v-img>
                    <p v-if="n==11" class="imgText">Avance hacia una economía circular</p>
                    <v-img v-if="n==12" src="../assets/banner/foto11.jpg" class="initialImg"></v-img>
                    <p v-if="n==12"  class="imgText">Plan único de amianto</p>
                    <v-img v-if="n==13" src="../assets/banner/foto37.jpg" class="initialImg"></v-img>
                    <p v-if="n==13" class="imgText">Transporte de residuos, sandach, ADR</p>
                    <v-img v-if="n==14" src="../assets/banner/foto31.jpg" class="initialImg"></v-img>
                    <p v-if="n==14" class="imgText">Eficiencia Energética </p>
                    <v-img v-if="n==15" src="../assets/banner/foto24.jpg" class="initialImg"></v-img>
                    <p v-if="n==15" class="imgText">Trámite de documentación con la administración</p>
                    <v-img v-if="n==16" src="../assets/banner/foto25.jpg" class="initialImg"></v-img>
                    <p v-if="n==16" class="imgText">Personal cualificado</p>
                    </div>
                </div>
            </v-card-text>
        </v-card>
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
export default {
  name: 'Contacto',
  props: {
    msg: String
  },
  data() {
      return {
            length: 16,
            window: 0,
            showArrows: false,
            vertical: false,
            reverse: false,
            autorun: true
      }
  },
  created(){
      setInterval(() => {
        if (!this.autorun) return
        if (++this.window >= this.length) this.window = 0
      }, 5000)
  }
}
</script>

<style scoped>
#container{
  width: 90%;
  padding-left: auto;
  padding-right: auto;
  margin: auto;
  vertical-align: 50%;
}
/*
.imgText {
	animation: textMove 10s infinite;
  font-size: 60px;
  padding-top: 20px;
  position: absolute;
  padding: auto;
  text-align: center;
  width: 100%;
  padding: 10px;
  -webkit-text-stroke: 2px black;
  color: white;
}*/
.imgText {
	animation: textMove 5s infinite;
  font-size: 80px;
  padding-top: 20px;
  position: absolute;
  padding: auto;
  text-align: center;
  width: 100%;
  padding: 10px;
  color: white;
  line-height: 0.8;
}

@keyframes textMove {
    0%   {top:5%;}
    80%  {top:40%;}
    100% {top:40%;}
}

#imgContainer{
    width: 100%;
    height: 500px;
    max-height: 400px;
    overflow: hidden;

}

.initialImg {
	animation: zoom 10s infinite;
  height: 500px;
    max-height: 400px;
}

@keyframes zoom {
  from {transform: scale(1);}
  to {transform: scale(1.2);}
}
</style>